import { useRef, useState, useEffect } from "react";
import "./AudioBurbuja.css";

function AudioBurbuja({ src, esPropio, onPlayGlobal }) {
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;
        const handlePause = () => setPlaying(false);
        const handlePlay = () => setPlaying(true);

        audio.addEventListener("pause", handlePause);
        audio.addEventListener("play", handlePlay);
        audio.addEventListener("ended", () => setPlaying(false));

        const updateProgress = () => {
            setProgress((audio.currentTime / audio.duration) * 100 || 0);
        };
        const setMeta = () => {
            setDuration(audio.duration || 0);
        };
        audio.addEventListener("timeupdate", updateProgress);
        audio.addEventListener("loadedmetadata", setMeta);
        return () => {
            audio.removeEventListener("timeupdate", updateProgress);
            audio.removeEventListener("loadedmetadata", setMeta);

            audio.removeEventListener("pause", handlePause);
            audio.removeEventListener("play", handlePlay);
        };

    }, []);

    const togglePlay = () => {
        if (!audioRef.current) return;

        if (playing) {
            audioRef.current.pause();
        } else {
            if (onPlayGlobal) {
                onPlayGlobal(audioRef.current);
            }

            audioRef.current.play().catch(() => {});
        }
    };

    const formatTime = (sec) => {
        if (!sec) return "0:00";
        const m = Math.floor(sec / 60);
        const s = Math.floor(sec % 60);
        return `${m}:${s < 10 ? "0" : ""}${s}`;
    };

    return (
        <div className={`audio-bubble ${esPropio ? "propio" : "recibido"}`}> 
            <button className="play-btn" onClick={togglePlay}>
                {playing ? <i className="fa-solid fa-pause"></i> : <i className="fa-solid fa-play"></i>}
            </button>

            <div className="audio-body">
                <div className="progress-bar">
                    <div 
                        className="progress" 
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>

                <div className="time">
                    {formatTime(audioRef.current?.currentTime)} / {formatTime(duration)}
                </div>
            </div>

            <audio ref={audioRef} src={src} />
        </div>
    );
}

export default AudioBurbuja;